/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UtenteRuoloAccessoInputDto interface.
 */
export function instanceOfUtenteRuoloAccessoInputDto(value) {
    return true;
}
export function UtenteRuoloAccessoInputDtoFromJSON(json) {
    return UtenteRuoloAccessoInputDtoFromJSONTyped(json, false);
}
export function UtenteRuoloAccessoInputDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'utente': json['utente'] == null ? undefined : json['utente'],
        'ruoloAccessoId': json['ruoloAccessoId'] == null ? undefined : json['ruoloAccessoId'],
    };
}
export function UtenteRuoloAccessoInputDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'utente': value['utente'],
        'ruoloAccessoId': value['ruoloAccessoId'],
    };
}
